import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import DateInput from '../DateInput/DateInput';
import TimeDropdown from '../TimeDropdown/TimeDropdown';

const DateTimeField = ({
  shownDate,
  placeholder,
  hasTimeDropdown,
  onChangeInput,
  stateKey,
  timeAriaLabel,
  className,
  onChangeTime,
}) => (
  <div className={className}>
    <DateInput
      onChangeAction={onChangeInput}
      stateKey={`${stateKey}Date`}
      initialDate={shownDate}
      placeholder={placeholder}
      className={clsx('fluid', {
        'pad-1-r': hasTimeDropdown,
      })}
    />
    {
        hasTimeDropdown && (
          <TimeDropdown
            ariaLabel={timeAriaLabel}
            stateKey={`${stateKey}Time`}
            onChangeAction={onChangeTime}
            className="fluid"
          />
        )
      }
  </div>
);

DateTimeField.propTypes = {
  shownDate: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  hasTimeDropdown: PropTypes.bool.isRequired,
  onChangeInput: PropTypes.func.isRequired,
  onChangeTime: PropTypes.func,
  stateKey: PropTypes.string.isRequired,
  timeAriaLabel: PropTypes.string,
  className: PropTypes.string,
};

export default DateTimeField;
